module.exports = __webpack_public_path__ + "img/宰相回宫.93c84b74.png";